import { useState, useEffect } from 'react';
import { useAPI } from '../services/apiService';
import { useAuth } from '../contexts/AuthContext';

const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes

let cachedUsers = null;
let lastFetchTime = null;

const logUsersError = (location, error) => {
  console.error(`[useUsers] Error in ${location}:`, {
    message: error.message,
    stack: error.stack
  });
};

export const useUsers = () => {
  const api = useAPI();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { user } = useAuth();

  const fetchUsers = async (force = false) => {
    try {
      if (!user) {
        return;
      }

      if (!force && cachedUsers && lastFetchTime && (Date.now() - lastFetchTime < CACHE_DURATION)) {
        setUsers(cachedUsers);
        setLoading(false);
        return;
      }

      const { data } = await api.get('/users/firm');
      
      if (!data) {
        throw new Error('No data returned from users fetch');
      }

      cachedUsers = data;
      lastFetchTime = Date.now();
      setUsers(data);
      setError(null);
    } catch (err) {
      console.error('[useUsers] Error fetching users:', err);
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (user) {
      fetchUsers().catch(error => {
        logUsersError('useEffect', error);
      });
    }
  }, [user]);

  return {
    users,
    loading,
    error,
    refetch: () => fetchUsers(true)
  };
}; 